import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    // constant routes paths set first at the top
    {
      path: '/',
      name: 'Home',
      component: require('@/components/home/Home').default,
      meta: { auth: true }
    },
    {
      path: '/login',
      name: 'LandingPage',
      component: require('@/components/landing-page/LandingPage').default,
      meta: { auth: false }
    },
    {
      path: '/clinics',
      name: 'Clinics',
      component: require('@/components/clinics/Clinics').default,
      meta: { auth: true }
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: require('@/components/authentication/Login').default,
    //   meta: { auth: false }
    // },
    {
      path: '/profile',
      name: 'User_Profile',
      component: require('@/components/users/Profile').default,
      meta: { auth: true }
    },
    {
      path: '/settings',
      name: 'User_Settings',
      component: require('@/components/users/Settings').default,
      meta: { auth: true }
    },
    {
      path: '/clinic/settings',
      name: 'Clinic_Settings',
      component: require('@/components/clinics/Settings').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/notifications',
      name: 'User_Notifications',
      component: require('@/components/notifications/Notifications').default,
      meta: { auth: true }
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: require('@/components/calendar/Calendar').default,
      meta: { auth: true }
    },
    {
      path: '/files',
      name: 'Files',
      component: require('@/components/folder/Files').default,
      meta: { auth: true }
    },
    {
      path: '/patients',
      name: 'Patients',
      component: require('@/components/patients/Patients').default,
      meta: { auth: true }
    },
    {
      path: '/reservations',
      name: 'Reservations',
      component: require('@/components/reservations/Reservations').default,
      meta: { auth: true }
    },
    {
      path: '/medical/machines',
      name: 'Medical_Machines',
      component: require('@/components/medical_machines/MedicalMachines')
        .default,
      meta: { auth: true }
    },
    {
      path: '/medical/machines/new',
      name: 'New_Medical_Machines',
      component: require('@/components/medical_machines/NewMedicalMachine')
        .default,
      meta: { auth: true }
    },
    {
      path: '/reservations/new',
      name: 'New_Reservation',
      component: require('@/components/reservations/ReservationForm').default,
      meta: { auth: true }
    },
    {
      path: '/reservation_types/new',
      name: 'New_Reservation_Type',
      component: require('@/components/reservation_types/NewReservationType')
        .default,
      meta: { auth: true }
    },
    {
      path: '/reservations/:id',
      name: 'Show_Reservation',
      component: require('@/components/reservations/Reservation').default,
      meta: { auth: true }
    },
    {
      path: '/reservations/update/:id',
      name: 'Update_Reservation',
      component: require('@/components/reservations/ReservationForm').default,
      meta: { auth: true }
    },
    // {
    //   path: '/packages/new',
    //   name: 'New_Package',
    //   component: require('@/components/packages/NewPackage').default,
    //   meta: { auth: true }
    // },
    {
      path: '/employees',
      name: 'Employees',
      component: require('@/components/employees/Employees').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/doctors',
      name: 'Doctors',
      component: require('@/components/doctors/Doctors').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/employees/new',
      name: 'New_Employee',
      component: require('@/components/employees/NewEmployee').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/doctors/new',
      name: 'New_Doctor',
      component: require('@/components/doctors/NewDoctor').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/doctors/:id/percentages',
      name: 'Percentages',
      component: require('@/components/doctors/Percentages').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: require('@/components/transactions/Transactions').default,
      meta: { auth: true }
    },
    {
      path: '/transactions/new-expense',
      name: 'New_Expense_Transaction',
      component: require('@/components/transactions/NewExpenseTransaction').default,
      meta: { auth: true }
    },
    {
      path: '/inventory/home',
      name: 'Inventory_Home',
      component: require('@/components/inventory_system/inventory_layout/InventoryHomePage')
        .default,
      meta: { auth: true }
    },
    {
      path: '/financial/home',
      name: 'Financial_Home',
      component: require('@/components/financial_system/financial_layout/FinancialHomePage')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/suppliers',
      name: 'Suppliers',
      component: require('@/components/inventory_system/companies/Companies')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/supliers/new',
      name: 'New_Supplier',
      component: require('@/components/inventory_system/companies/NewCompany')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/suppliers/:id',
      name: 'Show_Supplier',
      component: require('@/components/inventory_system/companies/Company')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/invoices',
      name: 'Invoices',
      component: require('@/components/inventory_system/invoices/Invoices')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/invoices/new',
      name: 'New_Purchased_Invoice',
      component: require('@/components/inventory_system/invoices/NewPurchasedInvoice')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/invoices/:id',
      name: 'Show_Invoice',
      component: require('@/components/inventory_system/invoices/Invoice')
        .default,
      meta: { auth: true }
    },
    {
      path: '/inventory/items',
      name: 'Items',
      component: require('@/components/inventory_system/items/Items').default,
      meta: { auth: true }
    },
    {
      path: '/inventory/items/new',
      name: 'New_Item',
      component: require('@/components/inventory_system/items/NewItem').default,
      meta: { auth: true }
    },
    {
      path: '/inventory/audit',
      name: 'Audit',
      component: require('@/components/inventory_system/reports/Audit').default,
      meta: { auth: true }
    },
    {
      path: '/inventory/items/:id',
      name: 'Show_Item',
      component: require('@/components/inventory_system/items/Item').default,
      meta: { auth: true }
    },
    // dynamic routes paths set second at the bottom
    {
      path: '/patients/:id',
      name: 'Show_Patient',
      component: require('@/components/patients/PatientLog').default,
      meta: { auth: true }
    },
    {
      path: '/patients/create',
      name: 'Create_Patient',
      component: require('@/components/patients/NewPatient').default,
      meta: { auth: true }
    },
    {
      path: '/patients/update/:id',
      name: 'Update_Patient',
      component: require('@/components/patients/NewPatient').default,
      meta: { auth: true }
    },
    {
      path: '/employees/:id',
      name: 'Show_Employee',
      component: require('@/components/employees/Employee').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/doctors/:id',
      name: 'Show_Doctor',
      component: require('@/components/doctors/Doctor').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/medical/machines/:id',
      name: 'Show_Medical_Machine',
      component: require('@/components/medical_machines/MedicalMachine')
        .default,
      meta: { auth: true }
    },
    {
      path: '/requests',
      name: 'Requests',
      component: require('@/components/approval_requests/ApprovalRequests')
        .default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/requests/:id',
      name: 'Show_Approval_Request',
      component: require('@/components/approval_requests/ApprovalRequest')
        .default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/reports',
      name: 'Financial_Report',
      component: require('@/components/financial_system/ClinicFinancialReport').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/transactions/audit',
      name: 'Transaction_Audit_Report',
      component: require('@/components/financial_system/DailyTransactionReport').default,
      meta: { auth: true }
    },
    {
      path: '/doctors/:id/reports',
      name: 'Doctor_Report',
      component: require('@/components/reports/DoctorFinancialReport').default,
      meta: { auth: 'doctor' }
    },
    {
      path: '/reservation_visits/finalize_visit/:reservationVisitId',
      name: 'Finalize_visit',
      component: require('@/components/visits/FinalizeVisit').default,
      meta: { auth: true }
    },
    {
      path: '/reservation_visits/:reservationVisitId',
      name: 'Show_Visit',
      component: require('@/components/visits/Visit').default,
      meta: { auth: true }
    },
    {
      path: '/reservations/:reservationId/reservation_visits/new',
      name: 'New_Visit',
      component: require('@/components/visits/NewVisit').default,
      meta: { auth: true }
    },
    {
      path: '/visits',
      name: 'Filtered_Visits',
      component: require('@/components/visits/FilteredVisits').default,
      meta: { auth: true }
    },
    {
      path: '/reservations/:reservationId/reservation_visits/:reservationVisitId/visits/:visitId',
      name: 'Update_Visit',
      component: require('@/components/visits/UpdateVisit').default,
      meta: { auth: true }
    },
    {
      path: '/financial/finialize/visits',
      name: 'Finalize_Visits_Financial',
      component: require('@/components/financial_system/FinilizeVisitsReport').default,
      meta: { auth: true }
    },
    {
      path: '/rooms/:id',
      name: 'Show_Room',
      component: require('@/components/rooms/Room').default,
      meta: { auth: true }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js